import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'search',
  name: '搜索框',
  icon: '搜',
  group: '基础组件',
  description: '展示搜索输入和提交入口',
  defaultProps: {
    placeholder: '请输入搜索内容',
    buttonText: '搜索'
  }
}
